import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const COOKIE_KEY = 'cookie_consent';

const CookieBanner = () => {
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem(COOKIE_KEY);

        if (consent === 'accepted') {
            const interval = setInterval(() => {
                if (window.gtag) {
                    window.gtag('consent', 'update', {
                        analytics_storage: 'granted'
                    });
                    clearInterval(interval);
                }
            }, 100);
        }

        if (!consent) {
            setOpen(true);
        }
    }, []);


    const handleAccept = () => {
        localStorage.setItem(COOKIE_KEY, 'accepted');

        if (window.gtag) {
            window.gtag('consent', 'update', {
                analytics_storage: 'granted'
            });
        }

        setOpen(false);
    };

    const handleReject = () => {
        localStorage.setItem(COOKIE_KEY, 'rejected');
        setOpen(false);
    };

    if (!open) return null;

    return (
        <Box
            sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                width: '100%',
                zIndex: 1300,
                backgroundColor: 'var(--sznodarkestblue)',
                color: 'white',
                px: 3,
                py: 2,
                boxShadow: '0 -4px 12px rgba(0,0,0,0.3)',
            }}
        >
            <Box
                sx={{
                    maxWidth: '1200px',
                    mx: 'auto',
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 2,
                }}
            >
                <Typography variant="body2">
                    {t('Cookies.BannerText')}{' '}
                    <Link
                        to={`/${lang}/sutibeallitasok`}
                        style={{ color: '#90caf9', textDecoration: 'underline' }}
                    >
                        {t('Cookies.MoreInfo')}
                    </Link>
                </Typography>

                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button
                        variant="outlined"
                        color="inherit"
                        onClick={handleReject}
                        sx={{
                            borderColor: 'rgba(255,255,255,0.7)',
                            color: 'white',
                            '&:hover': {
                                borderColor: 'white',
                                backgroundColor: 'rgba(255,255,255,0.08)',
                            },
                        }}
                    >
                        {t('Cookies.Reject')}
                    </Button>

                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleAccept}
                    >
                        {t('Cookies.Accept')}
                    </Button>
                </Box>
            </Box>
        </Box>
    );

};

export default CookieBanner;
